import axios from "axios"
import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"


export const businessAreaService = {
  fetchAll: async () => {
    const response = await axios.get(import.meta.env.VITE_AB_DATA_URL, {
      headers: {
        signature: 'fcf0fe3707d899ee65e148e2d670a130'
      }
    });
    return response.data;
  },
    fetchAllWithoutPaginate: async (params = {}) => {
      const response = await axiosInstance.get('/business-area', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/business-area/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/business-area', data )
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/business-area/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/business-area/${id}`)
      return response.data
    },
}